var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icono_eliminar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_494",
    "data-name": "Rect\\xE1ngulo 494",
    width: 20,
    height: 20,
    transform: "translate(1414 867)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_60",
    "data-name": "Enmascarar grupo 60",
    transform: "translate(-1414 -867)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "M4.938,0H8.043a.926.926,0,0,1,.692,1.014c0,.2,0,.393,0,.59,0,.215,0,.216.218.216.89,0,1.78,0,2.671,0a.98.98,0,0,1,.992.7c.116.327.222.657.33.986a.889.889,0,0,1,.028.49.8.8,0,0,1-.78.614c-.1,0-.186,0-.2.137-.05.649-.1,1.3-.155,1.948-.056.7-.108,1.4-.165,2.1-.077.948-.16,1.9-.237,2.843s-.148,1.907-.226,2.86a1.618,1.618,0,0,1-.2.68,1.56,1.56,0,0,1-.986.724H3.105a1.84,1.84,0,0,1-.747-.424,1.789,1.789,0,0,1-.444-1.224c-.038-.567-.087-1.134-.132-1.7q-.088-1.09-.178-2.179c-.045-.556-.088-1.113-.133-1.669q-.088-1.082-.177-2.164c-.048-.582-.1-1.164-.142-1.746-.011-.149-.069-.2-.212-.187a.852.852,0,0,1-.94-.6V3.6q.169-.5.338-1A1.007,1.007,0,0,1,1.421,1.82H4c.252,0,.253,0,.253-.26,0-.181,0-.362,0-.543A.941.941,0,0,1,4.938,0M6.587,4.607H2.364c-.248,0-.26.016-.238.267q.122,1.437.24,2.874c.078.958.149,1.917.226,2.875q.152,1.9.308,3.8a.518.518,0,0,0,.309.482.831.831,0,0,0,.335.05H9.6c.047,0,.093,0,.14,0a.5.5,0,0,0,.5-.5c.064-.778.125-1.556.189-2.333.1-1.21.2-2.42.3-3.631s.193-2.442.288-3.663c.017-.213.016-.214-.2-.214H6.587M6.5,3.635h5.185c.052,0,.1,0,.155,0,.1,0,.125-.044.091-.137-.058-.161-.109-.323-.163-.485-.079-.236-.079-.237-.322-.237h-9.9c-.041,0-.083,0-.124,0a.131.131,0,0,0-.142.1c-.07.211-.14.422-.212.633-.031.091.011.126.1.129.057,0,.114,0,.171,0H6.5M6.49,1.819c.367,0,.735,0,1.1,0,.119,0,.17-.042.167-.163-.005-.191,0-.383,0-.574,0-.1-.042-.14-.141-.14q-1.126,0-2.251,0c-.111,0-.143.054-.142.154,0,.181.006.362,0,.543-.006.134.044.184.18.181.362-.007.724,0,1.087,0",
    transform: "translate(1417.501 869.05)",
    fill: "#c40062"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.c28ce685a43f6e0f672ac716da8d2693.svg";
export { ForwardRef as ReactComponent };